import React, { Component } from 'react';
import { Container, Row, Col, ListGroup, ListGroupItem } from 'reactstrap';
import { API, AUTH_ERROR } from '../../Logic/API';
import { Storage } from '../../Logic/Storage';
import { TASK_GROUP_ID, GROUP_NAME } from '../../Logic/storageKeys';
import '../Spacing.css'

export class ChooseTasks extends Component {
    constructor(props) {
        super(props);

        this.state = { taskGroups: [], isLoading: true };

        this.props.showHostingNav(false);

        API.get('/gameplay/taskgroups')
            .then(resp => resp.json())
            .then(data => {
                this.setState({ taskGroups: data, isLoading : false, groupName : Storage.getValue(GROUP_NAME) });
            })
            .catch(e => {
                if (e.message === AUTH_ERROR) {
                    this.props.history.push('/play/join');
                }
            });
    }
    
    selectTaskGroup(taskGroupId) {
        Storage.setSessionValue(TASK_GROUP_ID, taskGroupId);
        this.props.history.push('/play/game/tasks');
    }

    renderElement(element) {
        return (
            <Row>
                <Col className="hidden-md"></Col>
                <Col lg="6"><div className="space-top space-bottom">{element}</div></Col>
                <Col className="hidden-md"></Col>
            </Row>
        );
    }

    renderLoadingMessage() {
        return this.renderElement(
            <p className='text-lg-center'><em>Lade Arbeitsbereiche...</em></p>
        );
    }

    renderTaskGroups(taskGroups) {
        return this.renderElement(
            <ListGroup>
                {taskGroups.map(taskGroup =>
                    <ListGroupItem key={taskGroup.Id} onClick={() => this.selectTaskGroup(taskGroup.Id)} >
                        <p className="font-weight-bold text-lg-center">{taskGroup.Name}</p>
                    </ListGroupItem>
                )}
            </ListGroup>
        );
    }

    render() {
        let taskGroups = this.state.isLoading
            ? this.renderLoadingMessage()
            : this.renderTaskGroups(this.state.taskGroups);

        return (
            <Container>
                <Row>
                    <Col className="hidden-md"></Col>
                    <Col lg="6"><h1 className="text-lg-center space-bottom">Willkommen in Gruppe "{this.state.groupName}"</h1></Col>
                    <Col className="hidden-md"></Col>
                </Row>
                <Row>
                    <Col className="hidden-md"></Col>
                    <Col lg="6"><h2 className="text-lg-center space-top space-bottom">Arbeitsbereich wählen</h2></Col>
                    <Col className="hidden-md"></Col>
                </Row>
                {taskGroups}
            </Container>
            
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Game/ChooseTasks.jsx